import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CustomLoader from '../common/CustomLoader';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { prepareValidationForMysql } from './common/common_utils';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import { MYSQL } from 'drapcode-constant';
import { iconForField } from '../../common/custom/icon-library';
import TooltipInfo from '../../common/docs/TooltipInfo';

export class ExternalDbSettingForm extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  handleUpdateMySqlSetting = async (values) => {
    const {
      mysqlDbName,
      mysqlDbPort,
      mysqlDbHostUrl,
      mysqlDbUser,
      mysqlDbPassword,
      mysqlDbSslEnabled,
      mysqlDbSslCa,
      mysqlDbSslCert,
      mysqlDbSslKey,
    } = values;
    const { actions, dataConnector } = this.props;
    const { selectedExternalDb } = dataConnector || {};
    const { projectId, projectVersion, uuid } = selectedExternalDb || {};

    if (mysqlDbName && mysqlDbPort && mysqlDbHostUrl) {
      const dataForUpdate = {
        projectId,
        projectVersion,
        type: 'MYSQL',
        externalDbUuid: uuid,
        setting: {
          mysqlDbName,
          mysqlDbPort,
          mysqlDbHostUrl,
          mysqlDbUser,
          mysqlDbPassword,
          mysqlDbSslEnabled,
          mysqlDbSslCa,
          mysqlDbSslCert,
          mysqlDbSslKey,
        },
      };
      console.log(
        '🚀 ~ ExternalDbSettingForm handleUpdateMySqlSetting ~ dataForUpdate:',
        dataForUpdate,
      );
      await actions.updateMySqlExternalDbSetting({
        dataForUpdate,
        externalDbUuid: uuid,
        projectId,
        projectVersion,
      });
      await actions.getExternalDataBase({ projectId, version: projectVersion });
      actions.openExternalDbSettingModal(null);
    }
  };

  handleCancel = () => {
    console.log('🚀 ~ ExternalDbSettingForm ~ this.props:', this.props);
    const { actions } = this.props;
    actions.openExternalDbSettingModal(null);
  };

  renderSettingForm = () => {
    const { dataConnector, type, dataSourceName, settingData } = this.props;
    console.log('🚀 ~ ExternalDbSettingForm ~ type:', type, '~ settingData:', settingData);

    switch (type) {
      case MYSQL: {
        const {
          mysqlDbHostUrl,
          mysqlDbName,
          mysqlDbPort,
          mysqlDbUser,
          mysqlDbPassword,
          mysqlDbSslEnabled,
          mysqlDbSslCa,
          mysqlDbSslCert,
          mysqlDbSslKey,
        } = settingData || {};
        const { saveMySqlDataInExternalDbPending } = dataConnector || '';
        return (
          <Formik
            initialValues={{
              dataSourceName: dataSourceName || '',
              mysqlDbHostUrl: mysqlDbHostUrl || '',
              mysqlDbUser: mysqlDbUser || '',
              mysqlDbPassword: mysqlDbPassword || '',
              mysqlDbName: mysqlDbName || '',
              mysqlDbPort: mysqlDbPort || 3306,
              mysqlDbSslEnabled: mysqlDbSslEnabled || false,
              mysqlDbSslCa: mysqlDbSslCa || '',
              mysqlDbSslCert: mysqlDbSslCert || '',
              mysqlDbSslKey: mysqlDbSslKey || '',
            }}
            validationSchema={prepareValidationForMysql}
            onSubmit={this.handleUpdateMySqlSetting}
          >
            {({ isSubmitting, values, setFieldValue }) => (
              <Form>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="DB Host URL"
                    icon="text"
                    infoIcon={true}
                    infoDescription={`Enter DB Host URL if you have or want to use. It acts as the endpoint for accessing and managing your database resources.`}
                  >
                    <Field
                      type="text"
                      name="mysqlDbHostUrl"
                      className="form-control form-control-sm"
                      placeholder="DB Host URL (eg. localhost)"
                    />
                    <ErrorMessage name="mysqlDbHostUrl" component="p" className="text-danger" />
                  </FormFieldWithLabel>
                </div>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="DB Port"
                    icon="text"
                    infoIcon={true}
                    infoDescription={
                      'Enter MySQL DB Port obtained from your MySQL project settings. This key is essential for your application to securely communicate with the MySQL backend services. Never share it publicly.'
                    }
                  >
                    <Field
                      type="number"
                      name="mysqlDbPort"
                      className="form-control form-control-sm"
                      placeholder="DB Port (eg. 3306)"
                    />
                    <ErrorMessage name="mysqlDbPort" component="p" className="text-danger" />
                  </FormFieldWithLabel>
                </div>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="DB Name"
                    icon="text"
                    infoIcon={true}
                    infoDescription={
                      'Enter MySQL DB Name.from your MySQL account Project section. This ID is necessary for your application to interact with the MySQL backend services.'
                    }
                  >
                    <Field
                      type="text"
                      name="mysqlDbName"
                      className="form-control form-control-sm"
                      placeholder="DB Name (eg. mydatabase)"
                    />
                    <ErrorMessage name="mysqlDbName" component="p" className="text-danger" />
                  </FormFieldWithLabel>
                </div>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="DB Username"
                    icon="text"
                    infoIcon={true}
                    infoDescription={
                      'Enter MySQL DB Username.from your MySQL account Project section. This ID is necessary for your application to interact with the MySQL backend services.'
                    }
                  >
                    <Field
                      type="text"
                      name="mysqlDbUser"
                      className="form-control form-control-sm"
                      placeholder="DB Username (eg. root)"
                    />
                    <ErrorMessage name="mysqlDbUser" component="p" className="text-danger" />
                  </FormFieldWithLabel>
                </div>

                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="DB Password"
                    icon="text"
                    infoIcon={true}
                    infoDescription={
                      'Enter MySQL DB Password.from your MySQL account Project section. This ID is necessary for your application to interact with the MySQL backend services.'
                    }
                  >
                    <Field
                      type="password"
                      name="mysqlDbPassword"
                      className="form-control form-control-sm"
                      placeholder="DB Password (eg. password)"
                    />
                    <ErrorMessage name="mysqlDbPassword" component="p" className="text-danger" />
                  </FormFieldWithLabel>
                </div>

                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-prepend" title="Enable SSL for Connection">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                      </span>
                    </div>
                    <div className="form-check">
                      <label className="form-check-label">
                        <Field
                          type="checkbox"
                          name="mysqlDbSslEnabled"
                          className="form-check-input"
                          title="Enable SSL for Connection"
                          checked={values['mysqlDbSslEnabled']}
                          onChange={() =>
                            setFieldValue('mysqlDbSslEnabled', !values['mysqlDbSslEnabled'])
                          }
                        />
                        Enable SSL for Connection
                        <span className="form-check-sign">
                          <span className="check"></span>
                        </span>
                      </label>
                    </div>
                    <TooltipInfo
                      title={`Enable it if your MySQL database requires SSL connection for enhanced security.`}
                      headerText={`What's this ?`}
                      showHeader={true}
                      showArrow={true}
                      append={true}
                    />
                  </div>
                  <ErrorMessage
                    name="mysqlDbSslEnabled"
                    component="p"
                    className="text-error ml-5"
                  />
                </div>

                {values['mysqlDbSslEnabled'] && (
                  <div style={{ marginLeft: '30px' }}>
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="SSL Ca"
                        icon="text"
                        infoIcon={true}
                        infoDescription={`Enter the SSL CA certificate file name (e.g., ca.pem) if your MySQL database requires it for secure connections.`}
                      >
                        <Field
                          type="text"
                          name="mysqlDbSslCa"
                          className="form-control form-control-sm"
                          autoComplete="off"
                          placeholder="SSL Ca (eg. ca.pem)"
                        />
                      </FormFieldWithLabel>
                      <ErrorMessage name="mysqlDbSslCa" component="p" className="text-error ml-5" />
                    </div>
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="SSL Cert (Optional)"
                        icon="text"
                        infoIcon={true}
                        infoDescription={`Enter the SSL Cert certificate file name (e.g., cert.pem) if your MySQL database requires it for secure connections.`}
                      >
                        <Field
                          type="text"
                          name="mysqlDbSslCert"
                          className="form-control form-control-sm"
                          autoComplete="off"
                          placeholder="SSL Cert (eg. cert.pem)"
                        />
                      </FormFieldWithLabel>
                      <ErrorMessage
                        name="mysqlDbSslCert"
                        component="p"
                        className="text-error ml-5"
                      />
                    </div>
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="SSL Key (Optional)"
                        icon="text"
                        infoIcon={true}
                        infoDescription={`Enter the SSL Key file name (e.g., key.pem) if your MySQL database requires it for secure connections.`}
                      >
                        <Field
                          type="text"
                          name="mysqlDbSslKey"
                          className="form-control form-control-sm"
                          autoComplete="off"
                          placeholder="SSL Key (eg. key.pem)"
                        />
                      </FormFieldWithLabel>
                      <ErrorMessage
                        name="mysqlDbSslKey"
                        component="p"
                        className="text-error ml-5"
                      />
                    </div>
                  </div>
                )}

                <div className="clearfix">
                  <button
                    className="btn btn-outline-secondary"
                    title="Cancel"
                    type="button"
                    onClick={this.handleCancel}
                  >
                    <i className="wb webconnect-times"></i> Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-theme-submit float-right"
                    disabled={isSubmitting || saveMySqlDataInExternalDbPending}
                  >
                    <i className="wb webconnect-save-regular"></i> &nbsp;Update&nbsp;
                    <CustomLoader loading={saveMySqlDataInExternalDbPending}></CustomLoader>
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        );
      }
      default:
        return <div>Form not available for this database type.</div>;
    }
  };

  render() {
    return this.renderSettingForm();
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalDbSettingForm);
